/*!
 * Arlo Skye accessibility framework — bundled build
 * Generated from 25 A11y_*.js modules, IIFE-scoped to prevent name
 * collisions (13 duplicate identifiers existed across the original modules).
 * Behavior is identical to loading the original modules in the order
 * used by the previous A11y_fixes.js entry point, with one critical fix:
 *
 *   A11y_homePage.js fixHeadingMarkup() selector scoped to `main` so it
 *   no longer injects role=heading aria-level=3 onto the footer newsletter
 *   <p class="h3">, which was causing the WCAG 1.3.1 outline violation
 *   (heading level 3 inside contentinfo landmark with no h2 parent).
 */
(function(){ window.A11y = window.A11y || {}; })();

/* ===== A11y_criticalFixes.js ===== */
(function(A11y){
/**
 * Critical Accessibility Fixes — February 2026
 * Addresses 3 of 5 critical issues flagged by AccessibilityChecker.org:
 *   1. ARIA roles on .shopify-dns-link-icon (Shopify-injected element)
 *   3. List structure corrections
 *   5. Scrollable content keyboard accessibility
 *
 * Issues #2 (contentinfo landmark) and #4 (viewport scale) are fixed in theme.liquid
 */

/**
 * Issue #1: Fix invalid ARIA role on .shopify-dns-link-icon
 * Shopify injects this img element via content_for_header with a role
 * that is not valid for <img> elements. We remove it or set role="img".
 */
const fixShopifyDnsLinkIcon = function () {
  const icons = document.querySelectorAll('.shopify-dns-link-icon');
  icons.forEach(function (icon) {
    // Remove any invalid ARIA role and ensure proper img semantics
    const currentRole = icon.getAttribute('role');
    if (currentRole && currentRole !== 'img' && currentRole !== 'presentation' && currentRole !== 'none') {
      icon.removeAttribute('role');
    }
    // If the image is decorative (no meaningful alt), mark as presentation
    if (!icon.getAttribute('alt') || icon.getAttribute('alt').trim() === '') {
      icon.setAttribute('role', 'presentation');
      icon.setAttribute('alt', '');
    } else {
      icon.setAttribute('role', 'img');
    }
  });
};

/**
 * Issue #3: Fix list structure violations
 * Ensures all <ul>/<ol> elements only contain valid <li> children,
 * and wraps any stray non-<li> direct children in <li> elements.
 * Also fixes <li> elements that aren't inside a <ul> or <ol>.
 */
const fixListStructure = function () {
  // Fix: <ul>/<ol> with non-<li> direct children
  document.querySelectorAll('ul, ol').forEach(function (list) {
    Array.from(list.children).forEach(function (child) {
      var tag = child.tagName.toLowerCase();
      if (tag !== 'li' && tag !== 'script' && tag !== 'template') {
        // If the child has role="listitem", it's fine semantically
        if (child.getAttribute('role') === 'listitem') return;
        // Wrap in <li>
        var li = document.createElement('li');
        li.style.display = 'contents'; // preserve layout
        list.insertBefore(li, child);
        li.appendChild(child);
      }
    });
  });

  // Fix: <li> elements not inside a <ul> or <ol>
  document.querySelectorAll('li').forEach(function (li) {
    var parent = li.parentElement;
    if (parent) {
      var parentTag = parent.tagName.toLowerCase();
      if (parentTag !== 'ul' && parentTag !== 'ol' && parent.getAttribute('role') !== 'list') {
        li.setAttribute('role', 'listitem');
        var span = document.createElement('span');
        span.innerHTML = li.innerHTML;
        li.replaceWith(span);
      }
    }
  });
};

/**
 * Issue #5: Make scrollable elements keyboard accessible
 * Finds elements with overflow scroll/auto that contain scrollable content
 * and adds tabindex="0" so keyboard users can scroll them.
 * Does NOT add role="region" to avoid landmark uniqueness conflicts.
 */
const fixScrollableKeyboardAccess = function () {
  var scrollableSelectors = [
    '.scroll-area',
    '[class*="scrollable"]',
    '.announcement-bar__static-list',
    '.announcement-bar__scrolling-list',
    'marquee-text',
    '.product-list',
    '.collection-list',
  ];

  var allElements = document.querySelectorAll(scrollableSelectors.join(', '));

  allElements.forEach(function (el) {
    makeScrollableAccessible(el);
  });

  // Broader check: find any element with overflow that creates scrollable area
  document.querySelectorAll('*').forEach(function (el) {
    var style = window.getComputedStyle(el);
    var isScrollableX = (style.overflowX === 'scroll' || style.overflowX === 'auto') && el.scrollWidth > el.clientWidth;
    var isScrollableY = (style.overflowY === 'scroll' || style.overflowY === 'auto') && el.scrollHeight > el.clientHeight;

    if (isScrollableX || isScrollableY) {
      makeScrollableAccessible(el);
    }
  });
};

function makeScrollableAccessible(el) {
  if (el.hasAttribute('tabindex')) return;
  var tag = el.tagName.toLowerCase();
  if (['a', 'button', 'input', 'select', 'textarea'].includes(tag)) return;

  el.setAttribute('tabindex', '0');

  // Don't add role="region" — that creates landmark uniqueness issues.
  // tabindex="0" alone is sufficient for keyboard scrollability.
}

A11y.applyCriticalFixes = function () {
  fixShopifyDnsLinkIcon();
  fixListStructure();
  fixScrollableKeyboardAccess();
};
})(window.A11y = window.A11y || {});

/* ===== A11y_loginPage.js ===== */
(function(A11y){
const modifyPageTitle = function(expectedPageTitle) {
    let titleElement = document.querySelector("head > title");
    titleElement.innerText = expectedPageTitle;
}

const fixAutocompleteForEMail = function() {
    let inputField = document.querySelector('#captcha_form input[type="email"]');
    if(inputField) {
        inputField.setAttribute('autocomplete', 'email');
    }
}

const fixLogoAlt = function() {
    let image = document.querySelector('#shop-logo');
    if(image) {
        image.setAttribute('alt', "ArloSkye");
    }
}

A11y.applyLoginPageFixes = function() {
    const url = window.location.href;
    console.log("Url", url);

    if (url.includes("/authentication")) {
        console.log("Login page detected. Applying fixes...");
        modifyPageTitle("Login");
        fixAutocompleteForEMail();
        fixLogoAlt();
    } else {
        console.log("Not on the login page. Skipping login fixes.");
    }
}
})(window.A11y = window.A11y || {});

/* ===== A11y_header.js ===== */
(function(A11y){
function getZoomLevel() {
    const zoom = Math.round(window.devicePixelRatio * 100);
    return zoom;
  }
  
  const removeHiddenClassFromAccountLink = function () {
    const accountLink = document.querySelector('div.header__secondary-nav > div > a:nth-child(3)');
    if (accountLink) {
      accountLink.classList.remove('hidden');
    }
  };
  
  function executeBasedOnZoom() {
    const zoomLevel = getZoomLevel();
    
    if (zoomLevel > 200) {
      removeHiddenClassFromAccountLink();
    }
  }
  
  const updateCartAriaLabel = function () {
    const cartLink = document.querySelector('a.relative.tap-area');
    if (cartLink) {
      cartLink.removeAttribute('aria-expanded');
      
      // Ensure aria-expanded is permanently removed
      const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
          if (mutation.attributeName === 'aria-expanded') {
            cartLink.removeAttribute('aria-expanded');
          }
        });
      });
  
      observer.observe(cartLink, { attributes: true });
  
      cartLink.setAttribute('aria-haspopup', 'dialog');
  
      const itemCountElement = cartLink.querySelector('.header__cart-count .count-bubble');
      if (itemCountElement) {
        const itemCount = itemCountElement.textContent.trim();
        const newAriaLabel = `Cart - ${itemCount} items`;
        cartLink.setAttribute('aria-label', newAriaLabel);
      }
    } 
  };
  
  const moveLogoFirst = function () {
    const logoElement = document.querySelector('.header__logo');
    const wrapperElement = document.querySelector('.header__wrapper');
    if (logoElement && wrapperElement) {
      wrapperElement.insertBefore(logoElement, wrapperElement.firstChild);
    }
  };
  
  const fixSkipContent = function () {
    let skipLink = document.querySelector('a.skip-to-content');
    if (skipLink) {
      skipLink.addEventListener('click', function (event) {
        event.preventDefault();
        const mainContent = document.querySelector('main');
        if (mainContent) {
          mainContent.setAttribute('tabindex', '-1');
          mainContent.focus();
          mainContent.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  };
  
  const addLabelToOfferCarousel = function () {
    const announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar) {
      const aside = announcementBar.closest('aside');
      if (aside) {
        aside.setAttribute('aria-label', 'Offers');
      }
    }
  };
  
  function fixLogoAccessibility() {
    const logoContainer = document.querySelector(".header__logo");
  
    if (!logoContainer) {
      return;
    }
  
    const srOnlySpan = logoContainer.querySelector(".sr-only");
    if (srOnlySpan) {
      srOnlySpan.setAttribute("aria-hidden", "true");
    }
  
    const logoImage = logoContainer.querySelector("img");
    if (logoImage && !logoImage.getAttribute("alt")) {
      logoImage.setAttribute("alt", "Arlo Skye");
    }
  }
  
  A11y.applyHeaderFixes = function () {
      window.addEventListener('resize', function () {
        requestAnimationFrame(executeBasedOnZoom);
      });
  
      // Call the zoom adjustment function immediately
      executeBasedOnZoom();
      fixLogoAccessibility();
  
      // Apply fixes related to header
      moveLogoFirst();
      fixSkipContent();
      addLabelToOfferCarousel();
      updateCartAriaLabel();
  };
})(window.A11y = window.A11y || {});

/* ===== A11y_homePage.js ===== */
(function(A11y){
const  fixHeadingMarkup = function() {
    let element = document.querySelector('.rich-text__wrapper p');
    if(element){
        element.setAttribute('role','heading');
        element.setAttribute('aria-level','2');
    }
    let h3Elements = document.querySelectorAll('main p.h3, main .testimonial p.bold');
    h3Elements.forEach(element => {
        // Skip decorative labels inside text-with-icons sections — these are
        // icon row callouts (Free shipping & returns, Lifetime warranty, etc.),
        // not semantic section headings. Marking them role=heading creates a
        // WCAG 1.3.1 heading-order violation because they have no h2 parent.
        if (element.closest('[class*="text-with-icons"]')) return;
        element.setAttribute('role', 'heading');
        element.setAttribute('aria-level', '3');
    });
  }
  
  const fixViewAllButton = function() {
    let viewAll = document.querySelector('a.text-with-icon');
    if (viewAll) {
        let h2 = viewAll.closest('div').querySelector('h2')?.textContent;
        if (h2 && viewAll) {
            viewAll.setAttribute('aria-label',`View all ${h2}`);
        }
    }
  }
  
  
  const fixRadioGroupforColor = function() {
    const fieldsets = document.querySelectorAll('fieldset.product-card__swatch-list');
    if (fieldsets.length > 0) {
        fieldsets.forEach(fieldset => {
            const titleElement = fieldset.parentElement.previousElementSibling?.firstElementChild;
            if (titleElement && titleElement.textContent) {
                const title = titleElement.textContent.trim();
                fieldset.setAttribute('role', 'radiogroup');
                fieldset.setAttribute('aria-label', `choose color for ${title}`);
            }
        });
    }
  }
  function updateColorSwatchTitles() {
    document.querySelectorAll('.color-swatch').forEach(label => {
        const span = label.querySelector('span.sr-only');
        if (span) {
            label.setAttribute('title', span.textContent.trim());
        }
    });
}
  
  const  manageCarousel = function(carouselSelector, carouselLabel) {
  const carouselElement = document.querySelector(carouselSelector);
  if(carouselElement) {
    let elementsToRemoveRegion = carouselElement.querySelectorAll("[role='region']");
    if(elementsToRemoveRegion){
      elementsToRemoveRegion.forEach(element => {
        element.removeAttribute('role');
      });
    }
    carouselElement.setAttribute("role", "region");
    carouselElement.setAttribute("aria-label", carouselLabel);
    carouselElement.setAttribute("aria-roledescription", "carousel");
  }
  
  };
  
  const altTexts = [
  "Conde Nast Traveller",
  "TIME",
  "Bloomberg",
  "NBC Select",
  "The Wall Street Journal WSJ",
  ];
  
  function addAltTagsToImages(altTexts) {
  const observer = new MutationObserver(() => {
    const carouselImages = document.querySelectorAll('div[aria-label="Press"] img');
    carouselImages.forEach((image, index) => {
      if (carouselImages.length!== 0) {
        image.setAttribute("alt", altTexts[index]);
      }
    });
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  }
  
  function updateImageAlts() {
      const images = document.querySelectorAll('.media-grid img');
      const altTextElements = document.querySelectorAll('.media-grid .h4');
  
      if (altTextElements.length > 0) {
          images.forEach((img,index)=>{
            img.setAttribute('alt',altTextElements[index].textContent.trim());
          })
      }
  }
  
const manageModalFocus = (dialog) => {
    let closeButton = dialog.querySelector('button[title="Close"]');
    let focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    let focusableElements = dialog.querySelectorAll(focusableSelectors);

    // Check if the close button or focusable elements are inside shadow DOM
    if (!closeButton || focusableElements.length === 0) {
        const shadowRoot = dialog.shadowRoot;
        if (shadowRoot) {
            closeButton = shadowRoot.querySelector('button[part="outside-close-button"]');
            focusableElements = shadowRoot.querySelectorAll(focusableSelectors);
        }
    }

    // Set focus on the close button if it exists
    if (closeButton) {
        closeButton.focus();
    }

    if (focusableElements.length > 0) {
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        // Trap focus inside the modal while it's open
        const trapFocus = (event) => {
            if (event.key === 'Tab') {
                if (event.shiftKey && event.target === firstElement) {
                    event.preventDefault();
                    lastElement.focus();
                } else if (!event.shiftKey && event.target === lastElement) {
                    event.preventDefault();
                    firstElement.focus();
                }
            }
        };

        // Add the event listener for focus trapping
        dialog.addEventListener('keydown', trapFocus);

        // Cleanup the event listener when the modal is closed
        const closeModal = () => {
            dialog.removeEventListener('keydown', trapFocus);
        };

        // Listen for close events to remove focus trapping
        if (closeButton) {
            closeButton.addEventListener('click', closeModal);
        }
    }
};

  
  // Function to ensure the autocomplete attribute is added to the email input field
  const addAutocompleteToEmailField = (dialog) => {
    const emailInput = dialog.querySelector('input[type="email"]');
    if (emailInput && !emailInput.hasAttribute('autocomplete')) {
      emailInput.setAttribute('autocomplete', 'email');
      console.log('Autocomplete attribute added to email input field');
    }
  };
  
  const makeEmailLabelPersistent = (dialog) => {
    const emailInput = dialog.querySelector('input[type="email"]');
    if (emailInput) {
      emailInput.setAttribute('aria-label', 'Enter your email here');
    }
  };
  
  const addLabelToDialog = (dialog) =>{
    dialog.setAttribute('aria-label','Sales and Offer');
  }

function observeWisepopsDialog() {
    const intervalId = setInterval(() => {
        const wisepopsRoot = document.getElementById('wisepops-root');
        if (wisepopsRoot) {
            // Select the wisepops instance dynamically
            const wisepopsInstance = wisepopsRoot.querySelector('[id^="wisepops-instance-"]');
            if (wisepopsInstance) {
                const shadowRoot = wisepopsInstance.shadowRoot;
                if (shadowRoot) {
                    const dialog = shadowRoot.querySelector('[role="dialog"]');
                    if (dialog) {
                        clearInterval(intervalId); // Stop polling once dialog is found
                        addLabelToDialog(dialog);
                        manageModalFocus(dialog); // Ensure focus is trapped
                        addAutocompleteToEmailField(dialog);
                        makeEmailLabelPersistent(dialog);
                    }
                }
            }
        }
    }, 500); // Reduce interval time for a faster response
}
function observeNavigationDrawer() {
    const drawer = document.getElementById("header-sidebar-menu");

    if (!drawer) return;

    const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
            if (mutation.type === "attributes" && mutation.attributeName === "style") {
                const isVisible = drawer.style.visibility === "visible" || drawer.hasAttribute("open");

                if (isVisible) {
                    console.log("hamburger Visible");
                    manageModalFocus(drawer);
                }
            }
        }
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ["style", "open"] });

    return observer;
}
  
  function addPauseControlToScrollingText() {
    // Select the marquee element
    const marquee = document.querySelector("marquee-text");
  
    // Check if the marquee element exists
    if (!marquee) {
      console.warn("No <marquee-text> element found.");
      return;
    }
  
    // Check if the button already exists
    const existingButton = document.getElementById("pause-scroll-button");
    if (existingButton) {
      console.warn("Pause button already exists.");
      return;
    }
  
    // Create the pause/play button
    const pauseButton = document.createElement("button");
    pauseButton.id = "pause-scroll-button";
    pauseButton.setAttribute("aria-label", "Pause scrolling text");
    pauseButton.setAttribute("aria-pressed", "false");
    pauseButton.textContent = "Pause";
    pauseButton.classList.add("scrolling-text__control");
  
    // Add the button to the DOM (inside the scrolling-text container)
    const scrollingTextContainer = document.querySelector(".scrolling-text");
    if (scrollingTextContainer) {
      scrollingTextContainer.appendChild(pauseButton);
    }
  
    // Get the original animation duration from CSS
    const originalAnimationDuration = getComputedStyle(marquee).getPropertyValue("--marquee-animation-duration");
  
    // Add click event listener to the button
    pauseButton.addEventListener("click", function () {
      const isPaused = marquee.style.getPropertyValue("--marquee-animation-duration") === "0s";
  
      if (isPaused) {
        // Resume the animation
        marquee.style.setProperty("--marquee-animation-duration", originalAnimationDuration);
        pauseButton.setAttribute("aria-pressed", "false");
        pauseButton.textContent = "Pause";
      } else {
        // Pause the animation
        marquee.style.setProperty("--marquee-animation-duration", "0s");
        pauseButton.setAttribute("aria-pressed", "true");
        pauseButton.textContent = "Play";
      }
    });
  }
  
const removeAriaExpandedFromMenuButton = function () {
    const button = document.querySelector('button[aria-controls="header-sidebar-menu"]');

    if (button) {
        button.removeAttribute('aria-expanded'); // Remove initially

        const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
                if (mutation.attributeName === 'aria-expanded') {
                    button.removeAttribute('aria-expanded');
                }
            });
        });

        // Observe attribute changes on the button
        observer.observe(button, { attributes: true, attributeFilter: ['aria-expanded'] });
    }
};

const fixLableForX = function(){
    let closeX = document.querySelector('#header-sidebar-menu > div > div > div > div.panel-footer.v-stack.gap-5 > ul > li:nth-child(2) > a');
    if(closeX){
        closeX.setAttribute('aria-label',"Follow us on X");
    }
}

  A11y.applyHomePageFixes = function() {
      observeNavigationDrawer();
      removeAriaExpandedFromMenuButton();
      fixLableForX();
      observeWisepopsDialog();
      updateColorSwatchTitles();
      updateImageAlts();
      fixHeadingMarkup();
      addAltTagsToImages(altTexts);
      fixViewAllButton();
      fixRadioGroupforColor();
      addPauseControlToScrollingText();
      manageCarousel(".press", "Press");
      manageCarousel(".shop-the-look", "Shop the look");
      manageCarousel('.announcement-bar__wrapper',"Offers");
  };
})(window.A11y = window.A11y || {});

/* ===== A11y_footer.js ===== */
(function(A11y){
const  fixHeadingMarkupFooter = function() {
    let elements = document.querySelectorAll('footer p.bold, .footer__block p.h3');
    elements.forEach(element => {
        element.setAttribute('role', 'heading');
        element.setAttribute('aria-level', '2');
    });
}

const  addFooterLandmark = function() {
    // Structural fix: footer-group was moved outside <main> in theme.liquid
    // so the <footer> element's implicit contentinfo role is now at top level.
    // No JS override needed.
}

const  fixDiscernibleText = function(){
    let link = document.querySelector('.footer__copyright a');
    if(link){
        link.setAttribute('aria-label',"Shopify");
        link.setAttribute('tabindex',-1);
        link.setAttribute('aria-hidden',true);
    }
}
const fixLableForX = function(){
    let closeX = document.querySelector('div.footer__aside-top > ul > li:nth-child(2) > a');
    if(closeX){
        closeX.setAttribute('aria-label',"Follow us on X");
    }
}
function addHeadingRoleToCCPASections() {
    const paragraphs = document.querySelectorAll('.prose p');
    const targetTexts = [
      "Your rights under the California Consumer Privacy Act",
      "How to opt out"
    ];

    paragraphs.forEach(p => {
      if (targetTexts.includes(p.textContent.trim())) {
        p.setAttribute("role", "heading");
        p.setAttribute("aria-level", "3");
      }
    });
  }

A11y.applyFooterFixes = function() {
  fixHeadingMarkupFooter();
  
  addFooterLandmark();
  
  fixDiscernibleText();

  fixLableForX();

  if (window.location.href.includes("/ccpa-opt-out")){
      addHeadingRoleToCCPASections();
  }
}
})(window.A11y = window.A11y || {});

/* ===== A11y_CartPage.js ===== */
(function(A11y){
const autoCompleteArray = [
    "country",        // For country input field
    "address-level1", // For province/state input field
    "postal-code"     // For ZIP code input field
  ];
  
  function addAutoCompleteToFormFields() {
      const form = document.querySelector('.shipping-estimator__form');
      if (form) {
          let inputFields = form.querySelectorAll('select, input');
          if (inputFields.length > 0) {
              inputFields.forEach((field, index) => {
                  if (autoCompleteArray[index]) {
                      field.setAttribute("autocomplete", autoCompleteArray[index]);
                  }
              });
          }
      }
  }
  
  
  // MutationObserver to check when .accordion__content becomes visible
  function observeAccordionContent() {
      const targetNode = document.querySelector('.accordion__content');
      
      if (!targetNode) return; // Exit if target does not exist
  
      const observer = new MutationObserver((mutationsList) => {
          mutationsList.forEach(mutation => {
              if (mutation.attributeName === "style") {
                  const computedStyle = window.getComputedStyle(targetNode);
                  
                  if (computedStyle.opacity === "1") {
                      addAutoCompleteToFormFields();
                  }
              }
          });
      });
  
      observer.observe(targetNode, { attributes: true });
  }
  
  const fixIncompleteHeaders = () => {
      // Select all table rows inside tbody
      const rows = document.querySelectorAll(".order-summary__body tr");
  
      rows.forEach(row => {
          const firstCell = row.querySelector("td:first-child");
          if (firstCell) {
              // Convert first <td> to <th> with scope="row"
              const rowHeader = document.createElement("th");
              rowHeader.setAttribute("scope", "row");
              rowHeader.innerHTML = firstCell.innerHTML; // Preserve content
              rowHeader.className = firstCell.className; // Preserve styling
              firstCell.replaceWith(rowHeader);
          }
      });
  
      console.log("✅ Table header fix applied successfully!");
  };
  
  
  
  A11y.applyCartFixes = () => {
      if (window.location.href.includes("/cart")) {
          addAutoCompleteToFormFields();
          observeAccordionContent();
          fixIncompleteHeaders();
      }
  };
})(window.A11y = window.A11y || {});

/* ===== A11y_allProductsPage.js ===== */
(function(A11y){
const fixRadioGroupforColor = function() {
    const fieldsets = document.querySelectorAll('fieldset.product-card__swatch-list');
    if (fieldsets.length > 0) {
        fieldsets.forEach(fieldset => {
            const titleElement = fieldset.parentElement.previousElementSibling?.firstElementChild;
            if (titleElement && titleElement.textContent) {
                const title = titleElement.textContent.trim();
                fieldset.setAttribute('role', 'radiogroup');
                fieldset.setAttribute('aria-label', `choose color for ${title}`);
            }
        });
    }
}  

function updateColorSwatchTitles() {
    document.querySelectorAll('.color-swatch').forEach(label => {
        const span = label.querySelector('span.sr-only');
        if (span) {
            label.setAttribute('title', span.textContent.trim());
        }
    });
}



function updateProductTitles() {
    document.querySelectorAll('.product-card__title').forEach(span => {
        span.setAttribute('role', 'heading');
        span.setAttribute('aria-level', '2');
    });
}

A11y.applyProductListFixes = function() {
  const currentUrl = window.location.href;
  if(currentUrl.includes("/collections")) {
    //add grouping label to the color radiobuttons.
    fixRadioGroupforColor();
    updateProductTitles();
    updateColorSwatchTitles();
  }
  
}
})(window.A11y = window.A11y || {});

/* ===== A11y_ProductDetailedPage.js ===== */
(function(A11y){
// updated - 

const zoomLabels = function () {
    let zoomButtons = document.querySelectorAll(
      '.product-gallery__media button[is="product-zoom-button"]'
    );
    if (zoomButtons.length > 0) {
      zoomButtons.forEach((zoomButton) => {
        let imageElement = zoomButton
          .closest(".product-gallery__media")
          .querySelector("img");
        if (imageElement) {
          let imageAltText = imageElement.getAttribute("alt");
          if (imageAltText) {
            zoomButton.setAttribute("aria-label", `Zoom ${imageAltText}`);
          }
        }
      });
    }
  };
  
  function getAllInteractiveElements(element) {
    return Array.from(
      element.querySelectorAll(
        ":scope :is(button, a, input, select, textarea, details, summary)"
      )
    );
  }
  
  const fixFocusModalTrap = function (selector) {
    let dialog = document.querySelector(selector);
    if (dialog) {
      const elements = getAllInteractiveElements(dialog);
      const firstFocusableElement = elements[0];
      if (firstFocusableElement) {
        //firstFocusableElement.focus();
      }
  
      const lastFocusableElement = elements[elements.length - 1];
  
      dialog.addEventListener("keydown", function (e) {
        if (e.key === "Tab") {
          if (document.activeElement == lastFocusableElement && !e.shiftKey) {
            e.preventDefault();
            firstFocusableElement.focus();
          } else if (
            (document.activeElement === firstFocusableElement ||
              document.activeElement === dialog) &&
            e.shiftKey
          ) {
            e.preventDefault();
            lastFocusableElement.focus();
          }
        }
      });
    }
  };
  
  const fixRadioGroupforColor  = function () {
    const fieldset = document.querySelector("fieldset.variant-picker__option");
    if (fieldset) {
      const container = fieldset.closest("div.product");
      if (container) {
        const titleElement = container.querySelector("h1");
        if (titleElement && titleElement.textContent) {
          const title = titleElement.textContent.trim();
          const legendElement = fieldset.querySelector("legend");
          if (legendElement && legendElement.textContent.includes("Model")) {
            fieldset.setAttribute("aria-label", `choose Model for ${title}`);
          } else {
            fieldset.setAttribute("aria-label", `choose color for ${title}`);
          }
        }
      }
    }
  };
  function updateColorSwatchTitles() {
    document.querySelectorAll('.color-swatch').forEach(label => {
        const span = label.querySelector('span.sr-only');
        if (span) {
            label.setAttribute('title', span.textContent.trim());
        }
    });
}
  
  const paginationButtonLabels = function () {
    let prevButton = document.querySelector('.pagination .group[rel="prev"]');
    let nextButton = document.querySelector('.pagination .group[rel="next"]');
    if (prevButton) prevButton.setAttribute("aria-label", "Previous");
    if (nextButton) nextButton.setAttribute("aria-label", "Next");
  };
  
  const paginationAnnouncement = function () {
    let paginationContainer = document.querySelector(".pagination__current");
    if (paginationContainer)
      paginationContainer.setAttribute("aria-live", "polite");
  };
  
  const productImageAnnouncement = function () {
    const imageContainer = document.querySelector(".pswp__container");
    if (imageContainer) imageContainer.setAttribute("aria-live", "polite");
  };
  
  const tabControlsState = function () {
    let buttons = document.querySelectorAll(".oke-w-navBar button");
    buttons.forEach((button) => {
      const spanToRemove = button.querySelector(".oke-a11yText");
      if (spanToRemove) {
        spanToRemove.remove();
      }
    });
  };
  
  const fixFilterButtonState = function() {
    let filterButton = document.getElementById('filter-toggle');
    if(filterButton) {
      if(filterButton.classList.contains("oke-is-active")) {
        filterButton.setAttribute("aria-expanded", "true");
      }
      else {
        filterButton.setAttribute("aria-expanded", "false");
      }
    }
  }
  
  const reviewLabelNames = function () {
    try {
      const reviews = document.querySelectorAll(
        "ul.oke-w-reviews-list .oke-w-reviews-list-item"
      );
  
      if (!reviews || reviews.length === 0) return;
  
      reviews.forEach((review) => {
        const headingElement = review.querySelector(".oke-w-reviewer-name");
        if (!headingElement) return;
  
        const heading = headingElement.textContent.trim();
        if (!heading) return; // Ensure we don't add empty text
  
        const buttons = review.querySelectorAll(".oke-w-review-helpful button");
  
        if (!buttons || buttons.length === 0) return;
  
        buttons.forEach((button) => {
          if (!button) return;
  
          const isUniqueTextPresent = button.querySelector(".tekvision-a11y");
          if (!isUniqueTextPresent) {
            button.prepend(createSpan(heading));
          }
        });
      });
    } catch (error) {
      console.error("Error in reviewLabelNames:", error);
    }
  };
  
  function createSpan(textContent) {
    if (!textContent) return null;
  
    const span = document.createElement("span");
    span.className = "oke-a11yText tekvision-a11y";
    span.textContent = textContent;
  
    return span;
  }
  
  
  const fixHeadingMarkup = function () {
    let headingsH3 = document.querySelectorAll(
      ".images-scrolling-desktop__content-list p.h1, p.h2, p.h4"
    );
    headingsH3.forEach((element) => {
      element.setAttribute("role", "heading");
      element.setAttribute("aria-level", "3");
    });
    let h2Headings = document.querySelectorAll("p.hyphenate");
    h2Headings.forEach((element) => {
      element.setAttribute("role", "heading");
      element.setAttribute("aria-level", "2");
    });
  };
  
  
  const  manageCarousel = function(carouselSelector, carouselLabel) {
      const carouselElement = document.querySelector(carouselSelector);
      if(carouselElement) {
        carouselElement.setAttribute("role", "region");
        carouselElement.setAttribute("aria-label", carouselLabel);
        carouselElement.setAttribute("aria-roledescription", "carousel");
      }
      
  }
  
  const findShadowElement = function() {
    const outerShadowHost = document.querySelector("shopify-payment-terms");
  
    if (outerShadowHost) {
      const outerShadowRoot = outerShadowHost.shadowRoot;
  
      if (outerShadowRoot) {
        const innerShadowHost = outerShadowRoot.querySelector("shop-pay-installments-banner");
  
        if (innerShadowHost) {
          const innerShadowRoot = innerShadowHost.shadowRoot;
  
          if (innerShadowRoot) {
            const shadowElement = innerShadowRoot.querySelector("#shopify-installments-cta");
  
            if (shadowElement) {
              shadowElement.addEventListener("click", function() {
                setTimeout(() => {
                  const shadowModalContainer = document.querySelector("shopify-installments-prequal-modal")?.shadowRoot;
                  const modal = shadowModalContainer?.querySelector("#shopify-payment-terms-modal");
                  const closeButton = modal?.querySelector(".btn__close");
                  modal?.querySelector("shop-pay-button").shadowRoot?.querySelector("shop-pay-button-base").shadowRoot?.querySelector("a")?.setAttribute("aria-label", "Check if you qualify");
                  closeButton?.focus();
                  const lastAnchor = modal?.querySelectorAll('a')[modal.querySelectorAll('a').length - 1];
                  modal?.addEventListener("keydown", (e) => {
                    if (e.key === "Tab") {
                      if (shadowModalContainer.activeElement === lastAnchor && !e.shiftKey) {
                        e.preventDefault();
                        closeButton.focus();
                      } else if (shadowModalContainer.activeElement === closeButton && e.shiftKey) {
                        e.preventDefault();
                        lastAnchor.focus();
                      }
                    }
                  });
                }, 500);
              });
            } else {
              console.error("Shadow element inside inner shadow root not found.");
            }
          } else {
            console.error("Inner shadow root not found for inner shadow host.");
          }
        } else {
          console.error("Inner shadow host not found within outer shadow root.");
        }
      } else {
        console.error("Outer shadow root not found for outer shadow host.");
      }
    } else {
      console.error("Outer shadow host not found in the document.");
    }
  };
  
  const addLabelToAddButtons = function() {
    const addButtons =document.querySelectorAll("button.button.button--sm.button--subdued:not([data-action]):not([aria-label]):not([type='submit'])");
    if(addButtons && addButtons.length > 0) {
      addButtons.forEach(button => {
        const productName = button.parentElement.previousElementSibling.firstElementChild.textContent;
        button.setAttribute('aria-label', `Add ${productName}`);
      });
    }
  }
  
  const manageQuickAddModal = function() {
    const quickAddModals = document.querySelectorAll(".quick-buy-drawer__variant");
    if(quickAddModals && quickAddModals.length >0) {
      quickAddModals.forEach(element => {
        const quickAddModal = element.parentElement;
        const shadowElement = quickAddModal.shadowRoot;
        const closeButton = shadowElement.querySelector("div[part='content'] button");
        const addToCartButton = quickAddModal.querySelector("button[type='submit']");
        const productName = quickAddModal.querySelector("a").textContent;
        const fieldset = quickAddModal.querySelector("fieldset");
        quickAddModal.removeAttribute("aria-live");
        closeButton.setAttribute("tabindex", "1");
        setTimeout(() => {
          closeButton.focus();
        }, 100);
        fieldset.setAttribute("role", "group");
        fieldset.setAttribute("aria-label", `Choose color for ${productName}`);
        closeButton.addEventListener("keydown", e => {
          if(e.key === "Tab" && e.shiftKey) {
            e.preventDefault();
            addToCartButton.focus();
          }
        });
        addToCartButton.addEventListener("keydown", e => {
          if(e.key === "Tab" && !e.shiftKey) {
            e.preventDefault();
            closeButton.focus();
          }
        });
      });
    }
    
    
  
  }
  
  const descriptiveLinkTextForShowMoreLink = function() {
    const showMoreLink = document.querySelector(".oke-showMore-button");
    if(showMoreLink) {
      showMoreLink.setAttribute("aria-label", "Show more reviews");
    }
  }
  
  const addPressedStateToReviewButtons = function() {
    const buttons = document.querySelectorAll('.oke-helpful-vote-button');
    
    buttons.forEach(button => {
      if (button.classList.contains('oke-is-voted')) {
        button.setAttribute('aria-pressed', 'true');
      } 
      else {
        button.setAttribute('aria-pressed', 'false');
      }
      
      button.addEventListener("click", () => {
        setTimeout(() => {
          button.focus();
        }, 1000);
      });
    });
  }
  
  function implementTabRoleForCarouselDots() {
      const carouselDotsSection = document.querySelector("section.oke-mediaGallery-nav-slider.hooper");
      if (!carouselDotsSection) return;
  
      const carouselTabList = carouselDotsSection.querySelector("ul");
      if (!carouselTabList) return;
  
      const carouselTabsListItems = carouselTabList.querySelectorAll("li");
      const carouselTabs = carouselTabList.querySelectorAll("button");
      const selectedCarouselDot = carouselTabList.querySelector("li.hooper-slide.is-active.is-current button");
      if (!selectedCarouselDot) return;
  
      // Set initial attributes
      carouselDotsSection.setAttribute("tabindex", "-1");
      carouselTabList.setAttribute("role", "tablist");
      carouselTabList.setAttribute("aria-label", "Slides");
  
      carouselTabs.forEach(tab => {
          tab.setAttribute("role", "tab");
          tab.setAttribute("aria-selected", "false");
          tab.setAttribute("tabindex", "-1");
          
          const tabLabel = tab.parentElement.getAttribute("aria-label");
          tab.setAttribute("aria-label", tabLabel);
      });
  
      carouselTabsListItems.forEach(item => {
          item.setAttribute("role", "none");
          item.removeAttribute("tabindex");
          //item.removeAttribute("aria-label");
          
          const img = item.querySelector("img");
          if (img) {
              img.setAttribute("alt", "");
          }
      });
  
      selectedCarouselDot.setAttribute("aria-selected", "true");
      selectedCarouselDot.setAttribute("tabindex", "0");
  
      // Enable arrow key navigation
      carouselTabList.addEventListener("keydown", (event) => {
          const targetElement = handleArrowKeyNavigation(carouselTabs, event);
          
          if (targetElement) {
              updateTabAttributes(targetElement, carouselTabs);
              targetElement.focus();
          }
      });
  
      carouselTabs.forEach(tab => {
          tab.addEventListener("click", (event) => {
              updateTabAttributes(event.target, carouselTabs);
          });
      });
  
      const prevAndNextCarouselControls = document.querySelectorAll("button.oke-mediaGallery-nav-prev, button.oke-mediaGallery-nav-next");
      prevAndNextCarouselControls.forEach(control => {
          control.addEventListener("click", () => {
              const newSelectedCarouselDot = carouselTabList.querySelector("li.hooper-slide.is-active.is-current button");
              if (newSelectedCarouselDot) {
                  updateTabAttributes(newSelectedCarouselDot, carouselTabs);
              }
          });
      });
  }
  
  // Function to handle keyboard navigation
  function handleArrowKeyNavigation(focusableElements, event) {
      const { key } = event;
      let targetElement;
  
      if (key === "ArrowLeft") {
          const prevSibling = event.target.parentNode.previousElementSibling;
          targetElement = prevSibling ? prevSibling.querySelector("button") : focusableElements[focusableElements.length - 1];
      } else if (key === "ArrowRight") {
          const nextSibling = event.target.parentNode.nextElementSibling;
          targetElement = nextSibling ? nextSibling.querySelector("button") : focusableElements[0];
      }
      return targetElement;
  }
  
  // Function to update tabindex and aria-selected attributes
  function updateTabAttributes(targetElement, focusableElements) {
      setTimeout(() => {
          focusableElements.forEach(tab => {
              tab.setAttribute("tabindex", "-1");
              tab.setAttribute("aria-selected", "false");
              tab.parentNode.setAttribute("tabindex", "-1");
          });
          
          targetElement.setAttribute("aria-selected", "true");
          targetElement.setAttribute("tabindex", "0");
      }, 300);
  }
  
  const managingFocusLostOnPreviousAndNextCarouselControls = function() {
      let carouselPrevAndNextControls = document.querySelectorAll("button.oke-mediaGallery-nav-prev, button.oke-mediaGallery-nav-next");
      
      // Iterating through the controls and attaching a click event.
      carouselPrevAndNextControls.forEach((carouselControl) => {
          carouselControl.addEventListener("click", function (event) {
          // Checking if the control has 'disabled' attribute. If yes, then shifting the keyboard focus.
              if (event.target.getAttribute("disabled")) {
                  if (event.target === carouselPrevAndNextControls[0]) {
                      carouselPrevAndNextControls[carouselPrevAndNextControls.length - 1].focus();
                  }
                  else {
                      carouselPrevAndNextControls[0].focus();
                  }
              }
          });
      });
  }
  const disabledNextButonFocusTrap = function(){
    let carouselDotsTablist = document.querySelector("section.oke-mediaGallery-nav-slider.hooper div.hooper-list ul");
   
  carouselDotsTablist.addEventListener("keydown", function (event) {
      let nextButton = document.querySelector("button.oke-mediaGallery-nav-next");
      if (nextButton.getAttribute("disabled")) {
          if (event.key === "Tab" && event.shiftKey === false) {
              event.preventDefault();
          }
      }
  });
  }
  
  // function to handle focus reveiew section 
  const focusReviewsSection = function(){
    let button = document.querySelector('.oke-is-clickable');
    let reviewContainer = document.querySelector('.oke-w-review-reviewer');
    if(button && reviewContainer){
      button.addEventListener('click', function(){
        reviewContainer.focus();
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === "Enter" || e.key === " ") {
          reviewContainer.focus();
        }
      }, false); 
    }
  }
  
  const fixHeadingLevelsForAccordions = function() {
    const allToggles = document.querySelectorAll('div.section-stack__main .accordion__toggle');
  
    allToggles.forEach((toggle) => {
      const firstSpan = toggle.querySelector('span');
      if (firstSpan) {
        firstSpan.setAttribute("role", "heading");
        firstSpan.setAttribute("aria-level", "3");
      }
    });
  };
  
  const fixUnnecessaryAriaExpand = function() {
    const container = document.querySelector('.product-info__complementary-products .horizontal-product-list');
    
    if (container) {
      const removeAriaExpanded = () => {
        const allButtons = container.querySelectorAll('.horizontal-product__cta button');
        allButtons.forEach(item => {
          item.removeAttribute('aria-expanded');
        });
      };
  
      // Initial cleanup of the aria-expanded attribute
      removeAriaExpanded();
  
      // Set up a MutationObserver to watch for changes in the DOM
      const observer = new MutationObserver(() => {
        removeAriaExpanded();
      });
  
      // Observe the container for changes in child elements, subtree, and attributes
      observer.observe(container, {
        childList: true, // watch for added or removed child nodes
        subtree: true,   // observe all descendants
        attributes: true, // watch for attribute changes
        attributeFilter: ['aria-expanded'] // only observe changes to the aria-expanded attribute
      });
    }
  }
  
  function observeCartDrawer() {
    const cartDrawer = document.querySelector('.cart-drawer');
    const closeButton = cartDrawer?.querySelector('.close-button');
  
    if (!cartDrawer || !closeButton) return;
  
    const observer = new MutationObserver(() => {
      const isVisible = getComputedStyle(cartDrawer).visibility === 'visible';
      if (isVisible) {
        closeButton.focus();
      }
    });
  
    observer.observe(cartDrawer, { attributes: true, attributeFilter: ['style', 'class'] });
  }
  
  // functions for Payment Dialog
  
  function fixHeadingMarkupForPayment (dialog){
    let title = dialog.querySelector('.text-body-large');
    if(title) title.setAttribute('role','heading'); title.setAttribute('aria-level','2');
  }
  
  function fixAltForPaymentHeader (dialog){
    let headerSvg = dialog.querySelector('svg');
    if(headerSvg) headerSvg.setAttribute('role','image'); headerSvg.setAttribute('alt','Shop');
  }
  function updateFooterSVG(dialog) {
      const footer = dialog.querySelector('footer');
      if (footer) {
          const svg = footer.querySelector('svg');
          if (svg) {
              svg.setAttribute('role', 'img');
              svg.setAttribute('alt', 'Shop Pay');
          }
      }
  }
  function fixAutocompleteForEmailInput(dialog) {
    const emailInput = dialog.querySelector('input[type="email"]');
    if (emailInput) {
      if (emailInput.getAttribute('autocomplete') === 'email webauthn') {
        emailInput.setAttribute('autocomplete', 'email');
      } 
    }
  }

function styleButtonOnFocus(dialog) {
  const button = dialog.querySelector(
    'div[data-testid="check-if-you-qualify-button"] button'
  );
   if (button) {
    // Add focus event listener
    button.addEventListener("focus", () => {
      // Apply styles with higher specificity
      button.style.setProperty("outline", "solid 2px black", "important");
      button.style.setProperty("border-color", "black", "important");
      button.style.setProperty("box-shadow", "0 0 0 3px rgba(0, 0, 255, 0.5)", "important");
    });

    // Add blur event listener to remove styles when the button loses focus
    button.addEventListener("blur", () => {
      button.style.removeProperty("outline");
      button.style.removeProperty("border-color");
      button.style.removeProperty("box-shadow");
    });
  }
}


  
  function observeAndSelectAllDialogs() {
    // Select all elements with the specified data-nametag attribute
    const  firstDialog = document.querySelector('div[data-nametag="shop-portal-provider"]');
      const firstDialogShadowRoot = firstDialog.shadowRoot;
      if (firstDialogShadowRoot) {
        // Query for the section with role="dialog" in the first dialog
        const firstDialogSection = firstDialogShadowRoot.querySelector('section[role="dialog"]');
        if (firstDialogSection) {
          firstDialogSection.setAttribute("aria-label", "Get it now Pay Later");
          // Monitor the first dialog's visibility
          monitorDialogVisibility(firstDialogSection);
        }
      }
  }

function applyInertExcept() {
    document.querySelectorAll('body > *').forEach(child => {
        if (child.getAttribute('data-nametag') !== 'shop-portal-provider') {
            child.setAttribute('inert', '');
        } else {
            child.removeAttribute('inert');
        }
    });
}

function removeInertFromAll() {
    document.querySelectorAll('body > *').forEach(child => {
        if (child.hasAttribute('inert')) {
            child.removeAttribute('inert');
        }
    });
}


function applyStylesToShadowRoot() {
  const portalProvider = document.querySelector('div[data-nametag="shop-portal-provider"]');

  if (!portalProvider || !portalProvider.shadowRoot) {
    return;
  }

  const shadowRoot = portalProvider.shadowRoot;

  // Check if the style element already exists to prevent duplicate styles
  if (shadowRoot.getElementById("custom-shadow-styles")) {
    return;
  }

  // Create and apply styles
  const style = document.createElement("style");
  style.id = "custom-shadow-styles";
  style.textContent = `
    [data-testid="authorize-modal"] {
      max-height: 90vh;
      overflow-y: auto;
      width: auto;
      padding: 1rem;
    }

    [data-testid="authorize-modal"]::-webkit-scrollbar {
      display:none;
      width: 8px;
    }

    [data-testid="authorize-modal"]::-webkit-scrollbar-thumb {
      background-color: #888;
      border-radius: 4px;
    }

    [data-testid="authorize-modal"]::-webkit-scrollbar-track {
      display:none;
    }
  `;

  shadowRoot.appendChild(style);
}

function addTitleToIframe(){
  const productForm = document.querySelector('.product-info__payment-terms');
  console.log(productForm);
                if (productForm) {
                    const shopifyPaymentTerms = productForm.querySelector('shopify-payment-terms');
                    console.log(shopifyPaymentTerms);
                    if (shopifyPaymentTerms && shopifyPaymentTerms) {
                        let shadowRootElement = shopifyPaymentTerms.shadowRoot;
                        console.log(shadowRootElement);
                        let iFrame = shadowRootElement.querySelector('iframe');
                        console.log(iFrame)
                        if(iFrame){
                          iFrame.setAttribute("title","Get Now Pay later");
                        }
                    } 
                }

}

function focusTriggeringElementForPayLaterModal(dialog){
    const closeButton = dialog.querySelector('button[aria-label="Close"]');

    if (closeButton) {
        closeButton.addEventListener("click", () => {
            setTimeout(() => {
                removeInertFromAll();
                const productForm = document.querySelector('.product-info__payment-terms');
                if (productForm) {
                    const shopifyPaymentTerms = productForm.querySelector('shopify-payment-terms');
                    if (shopifyPaymentTerms && shopifyPaymentTerms) {
                        let shadowRootElement = shopifyPaymentTerms.shadowRoot;
                        const purchasingPowerButton = shadowRootElement.querySelector('#shopify-installments-cta');
                        if (purchasingPowerButton) {
                            purchasingPowerButton.focus();
                        } 
                    } 
                }
            }, 400);
        });
    }
}

  // Function to monitor the data-visible attribute of the first modal dialog
  function monitorDialogVisibility(dialogSection) {
    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-visible') {
          if (dialogSection.getAttribute('data-visible') === 'true') {
            // Perform functions for the first dialog
            applyInertExcept();
            focusTriggeringElementForPayLaterModal(dialogSection);
            fixHeadingMarkupForPayment(dialogSection);
            fixAltForPaymentHeader(dialogSection);
            updateFooterSVG(dialogSection);
            styleButtonOnFocus(dialogSection);
            applyStylesToShadowRoot();
            // Add a click event listener to the "Check if you qualify" button inside the first dialog
            const secondButton = dialogSection.querySelector('[data-testid="prequal-button-text"]');
            if (secondButton) {
              secondButton.addEventListener('click', () => {
                // No need to set up an observer here; the second dialog will be monitored when found.
              });
            }
          }
          if (dialogSection.getAttribute('data-visible') === 'false'){
            removeInertFromAll();
          }
        }
      }
    });
  
    // Start observing the dialogSection for attribute changes
    observer.observe(dialogSection, { attributes: true });
    return observer;
  }
  
  // Function to set up the MutationObserver for the first dialog
  function setupMutationObserverForFirstDialog() {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          // Check if the first modal dialog is added
          const dialogSection = observeAndSelectDialog();
          if (dialogSection) {
            // If found, monitor its visibility
            monitorDialogVisibility(dialogSection);
            // Disconnect the observer after the first dialog is found
            observer.disconnect();
          }
        }
      }
    });
  
    // Start observing the document with the configured parameters
    observer.observe(document.body, { childList: true, subtree: true });
    return observer;
  }
  
  // // Add a click event listener to the first button (View sample plans)
  // const firstButton = document.querySelector('#shopify-installments-cta');
  // if (firstButton) {
  //   firstButton.addEventListener('click', () => {
  //     console.log("Click got called for first button");
  //     const observer = setupMutationObserverForFirstDialog();
  
  //     // Optionally, you can set a timeout to disconnect the observer after a certain period
  //     setTimeout(() => {
  //       observer.disconnect();
  //     }, 10000); // Disconnect after 10 seconds (adjust as needed)
  //   });
  // }
  
  function checkForEmptyResults() {
    const reviewsMain = document.querySelector('.oke-w-reviews-main');
    const emptyResults = reviewsMain?.querySelector('.oke-w-reviews-emptyResults');
  
    if (emptyResults) {
      // Add role="alert" and aria-live="assertive" to the emptyResults element
      emptyResults.setAttribute('role', 'alert');
      emptyResults.setAttribute('aria-live', 'assertive');
    }
  }
  
  function addPauseControlToScrollingText() {
    // Select the marquee element
    const marquee = document.querySelector("marquee-text");
  
    // Check if the marquee element exists
    if (!marquee) {
      console.warn("No <marquee-text> element found.");
      return;
    }
  
    // Check if the button already exists
    const existingButton = document.getElementById("pause-scroll-button");
    if (existingButton) {
      console.warn("Pause button already exists.");
      return;
    }
  
    // Create the pause/play button
    const pauseButton = document.createElement("button");
    pauseButton.id = "pause-scroll-button";
    pauseButton.setAttribute("aria-label", "Pause scrolling text");
    pauseButton.setAttribute("aria-pressed", "false");
    pauseButton.textContent = "Pause";
    pauseButton.classList.add("scrolling-text__control");
  
    // Add the button to the DOM (inside the scrolling-text container)
    const scrollingTextContainer = document.querySelector(".scrolling-text");
    if (scrollingTextContainer) {
      scrollingTextContainer.appendChild(pauseButton);
    }
  
    // Get the original animation duration from CSS
    const originalAnimationDuration = getComputedStyle(marquee).getPropertyValue("--marquee-animation-duration");
  
    // Add click event listener to the button
    pauseButton.addEventListener("click", function () {
      const isPaused = marquee.style.getPropertyValue("--marquee-animation-duration") === "0s";
  
      if (isPaused) {
        // Resume the animation
        marquee.style.setProperty("--marquee-animation-duration", originalAnimationDuration);
        pauseButton.setAttribute("aria-pressed", "false");
        pauseButton.textContent = "Pause";
      } else {
        // Pause the animation
        marquee.style.setProperty("--marquee-animation-duration", "0s");
        pauseButton.setAttribute("aria-pressed", "true");
        pauseButton.textContent = "Play";
      }
    });
  }
  
  function addPlayPauseControlToVideos() {
    // Select all video elements inside the media container
    const videos = document.querySelectorAll(".media-with-text__media video");
  
    if (videos.length === 0) {
      console.warn("No video elements found.");
      return;
    }
  
    videos.forEach((video, index) => {
      // Ensure each video has a parent container (video-media element)
      const videoMediaElement = video.closest("video-media");
  
      if (!videoMediaElement) {
        console.warn(`No <video-media> element found for video ${index + 1}.`);
        return;
      }
  
      // Get the parent container of the <video-media> element
      const videoMediaParent = videoMediaElement.parentElement;
  
      if (!videoMediaParent) {
        console.warn(`No parent container found for <video-media> element ${index + 1}.`);
        return;
      }
  
      // Check if a button already exists for this video
      let playPauseButton = videoMediaParent.querySelector(".video-play-pause-button");
  
      if (!playPauseButton) {
        // Create the play/pause button
        playPauseButton = document.createElement("button");
        playPauseButton.classList.add("video-control-button", "video-play-pause-button");
        playPauseButton.setAttribute("aria-label", "Play video");
        playPauseButton.setAttribute("aria-pressed", "false");
        playPauseButton.textContent = "Pause";
  
        // Add the button as a sibling to the <video-media> element
        videoMediaParent.appendChild(playPauseButton);
      }
  
      // Click event for play/pause toggle
      playPauseButton.addEventListener("click", function () {
        if (video.paused) {
          video.play();
          playPauseButton.setAttribute("aria-label", "Pause video");
          playPauseButton.setAttribute("aria-pressed", "true");
          playPauseButton.textContent = "Pause";
        } else {
          video.pause();
          playPauseButton.setAttribute("aria-label", "Play video");
          playPauseButton.setAttribute("aria-pressed", "false");
          playPauseButton.textContent = "Play";
        }
      });
  
      // Reset button when video ends
      video.addEventListener("ended", function () {
        playPauseButton.setAttribute("aria-label", "Play video");
        playPauseButton.setAttribute("aria-pressed", "false");
        playPauseButton.textContent = "Play";
      });
    });
  }
  
  function observeModalContainer() {
    // Select the target node (body or a specific container)
    const targetNode = document.body;
  
    // Check if the modal container already exists
    const modalContainer = document.getElementById("oke-modalContainer");
    if (modalContainer) {
      focusCloseButton(modalContainer);
      return;
    }
  
    // Create a MutationObserver instance to watch for the modal container
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        // Check for added nodes
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => {
            // Check if the added node is the modal container or contains it
            if (node.nodeType === 1 && node.id === "oke-modalContainer") {
              focusCloseButton(node); // Focus the close button
              observer.disconnect(); // Stop observing once the modal is found
            }
          });
        }
      }
    });
  
    // Start observing the target node for changes
    observer.observe(targetNode, {
      childList: true, // Watch for added/removed nodes
      subtree: true,   // Watch all descendants of the target node
    });
  }
  
  // Helper function to focus the close button
  function focusCloseButton(modalContainer) {
    // Use a MutationObserver to wait for the close button to be added to the DOM
    const closeButtonObserver = new MutationObserver((mutationsList, observer) => {
      const dialog = modalContainer.querySelector('div[role="dialog"]');
      if (dialog) {
        const closeButton = dialog.querySelector('.oke-modal-close');
        if (closeButton) {
          closeButton.focus(); // Focus the close button
          observer.disconnect(); // Stop observing once the close button is found
        }
      }
    });
  
    // Start observing the modal container for changes
    closeButtonObserver.observe(modalContainer, {
      childList: true, // Watch for added/removed nodes
      subtree: true,   // Watch all descendants of the modal container
    });
  }
  
  function addHeadingAttributesToProductTitle() {
      const productTitles = document.querySelectorAll('.product-info__title');
      productTitles.forEach(title => {
          title.setAttribute('role', 'heading');
          title.setAttribute('aria-level', '2');
      });
  }
  
  function fixAccordionAccessibility() {
      document.querySelectorAll('.accordion__content').forEach(content => {
          content.setAttribute('role', 'list');
          const proseDiv = content.querySelector('.prose');
          if (!proseDiv) return;
          const paragraph = proseDiv.querySelector('p');
          if (paragraph) {
              const listItemsHTML = paragraph.innerHTML
                  .split('<br>')
                  .map(item => item.trim())
                  .filter(item => item !== '')
                  .map(item => `<div role="listitem">${item}</div>`) 
                  .join('');
              proseDiv.innerHTML = listItemsHTML;
          }
      });
  }
  function setAltValueForImage(altValue) {
    // Select the .multi-column container
    const multiColumn = document.querySelector('.multi-column');
  
    if (multiColumn) {
      // Select the second .multi-column__item div
      const secondItem = multiColumn.querySelector('.multi-column__item:nth-child(2)');
  
      if (secondItem) {
        // Select all img tags inside the second div
        const images = secondItem.querySelectorAll('img');
  
        images.forEach(img => {
          // Check if the img has no alt attribute or an empty alt attribute
          if (!img.hasAttribute('alt') || img.getAttribute('alt') === '') {
            // Set the alt attribute to the provided value
            img.setAttribute('alt', altValue);
          }
        });
      } 
    }
  }

const updateReadMoreButtons = () => {
    const reviewContainers = document.querySelectorAll(".oke-w-reviews-list-item");
    if (!reviewContainers || reviewContainers.length === 0) {
      return;
    }
    reviewContainers.forEach(container => {
      if (!container) {
        return;
      }
      const headingElement = container.querySelector(".oke-product-details a");
      if (!headingElement) {
        return; 
      }
      const headingText = headingElement?.textContent?.trim() || "this product";
      if (!headingElement.querySelector(".oke-a11yText")) {
        const a11ySpan = document.createElement("span");
        a11ySpan.classList.add("oke-a11yText");
        a11ySpan.textContent = headingText;
        headingElement.appendChild(a11ySpan);
      } 
      const truncatedReview = container.querySelector(".oke-w-review-main .oke-is-truncated");
      if (!truncatedReview) {
        return;
      }
      const readMoreButton = container.querySelector(".oke-readMore");
      if (!readMoreButton) {
        return;
      }
      if (!readMoreButton.querySelector(".oke-a11yText")) {
        const readMoreA11ySpan = document.createElement("span");
        readMoreA11ySpan.classList.add("oke-a11yText");
        readMoreA11ySpan.textContent = ` for ${headingText}`;
        readMoreButton.appendChild(readMoreA11ySpan);
      }
    });
};

// MutationObserver to monitor changes in the DOM
const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        if (mutation.type === "childList" || mutation.type === "subtree") {
            updateReadMoreButtons();
        }
    });
});

// Start observing the document body for changes
observer.observe(document.body, { childList: true, subtree: true });



  
  // Export the main function
  A11y.applyPDPFixes = function () {
    if (window.location.href.includes("/products")) {
      observeAndSelectAllDialogs();
  
      addHeadingAttributesToProductTitle();
  
      fixAccordionAccessibility();
  
      // Add labels to the zoom buttons
      zoomLabels();
  
      // Add grouping label to the radiobuttons
      fixRadioGroupforColor();

      updateColorSwatchTitles();

      updateReadMoreButtons();
  
      // Initial check for empty results
      checkForEmptyResults();
  
      // Fix state of tabs
      tabControlsState();
  
      // Fix heading markups
      fixHeadingMarkup();
      
      addTitleToIframe();
  
      // Find shadow elements
      findShadowElement();
  
      // Add unique label to the add(+) buttons
      addLabelToAddButtons();
  
      // Add descriptive text to the show more link
      descriptiveLinkTextForShowMoreLink();
  
      setAltValueForImage('Black Suitcase With Handle');
  
      // Focus review section
      focusReviewsSection();
  
      // Fix heading levels for accordions
      fixHeadingLevelsForAccordions();
  
      // Fix unnecessary aria-expanded attributes
      fixUnnecessaryAriaExpand();
  
      addPauseControlToScrollingText();
  
      addPlayPauseControlToVideos();
  
      observeModalContainer();
  
      // Observe cart drawer
      observeCartDrawer();
      
  
      
  
      // Work with the zoom modal
      const observer = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
          if (mutation.type === "childList") {
            // Handle zoom modal
            if (document.querySelector(".pswp--open[role='dialog']")) {
              fixFocusModalTrap('div.pswp--ui-visible');
              paginationButtonLabels();
              productImageAnnouncement();
              paginationAnnouncement();
            }
  
            // Handle reviews list
            if (document.querySelector(".oke-w-reviews-list")) {
              reviewLabelNames();
              addPressedStateToReviewButtons();
            }
  
            // Handle quick add modal
            if (document.querySelector(".quick-buy-drawer__variant")) {
              manageQuickAddModal();
            }
  
            // Handle OKE modal
            if (document.querySelector(".oke-modal-content[role='dialog']")) {
              fixFocusModalTrap(".oke-modal-content[role='dialog']");
              implementTabRoleForCarouselDots();
              managingFocusLostOnPreviousAndNextCarouselControls();
              disabledNextButonFocusTrap();
            }
  
            // Check for empty results whenever the DOM changes
            checkForEmptyResults();
          }
  
          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            // Handle reviews list for attribute changes
            if (document.querySelector(".oke-w-reviews-list")) {
              fixFilterButtonState();
              addPressedStateToReviewButtons();
            }
          }
        }
      });
  
      const config = {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ["class"]
      };
  
      observer.observe(document.body, config);
    }
  };
})(window.A11y = window.A11y || {});

/* ===== A11y_cartModal.js ===== */
(function(A11y){
const setAriaLabel = function (selector, containerSelector, prefix) {
    let elements = document.querySelectorAll(selector);
    elements.forEach(element => {
        let container = element.closest(containerSelector);
        if (container) {
            let heading = container.querySelector('a span');
            if (heading) {
                element.setAttribute('aria-label', `${prefix} - ${heading.innerText}`);
            }
        }
    });
}

const setCartHeading = function(){
    const heading = document.querySelector('#cart-drawer .cart-drawer__inner p[role="heading"]');
    const cartModal = document.querySelector('#cart-drawer');
    if(cartModal && heading) {
        cartModal.setAttribute("aria-label", heading.textContent);
    }
}

const removeAriaExpandedFromButton = function () {
    const button = document.querySelector('button[aria-controls="cart-drawer-note"]');
    if (button) {
        button.removeAttribute('aria-expanded');

        const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
                if (mutation.attributeName === 'aria-expanded') {
                    button.removeAttribute('aria-expanded');
                }
            });
        });

        observer.observe(button, { attributes: true });
    }
};

const removeAriaExpanded = function () {
    let cartToggle = document.querySelector('a[href="/cart"][aria-controls="cart-drawer"]');
    if (cartToggle) {
        cartToggle.removeAttribute('aria-expanded');
    }
}

const fixAddQuantityLabel = function () {
    setAriaLabel('.quantity-input', '.line-item', 'Change quantity for');
}

const fixRemoveButtonLabel = function() {
    setAriaLabel('.line-item__actions a.link', '.line-item', 'Remove');
}

const trendingCardsAddButtonsLabel = function(){
    let container = document.querySelector('.cart-drawer__recommendations');
    if(container){
        let addButtons = container.querySelectorAll('button.button');
        if(addButtons.length > 0){
            addButtons.forEach(button => {
                let heading = button.closest('.horizontal-product__info').querySelector('a span');
                if (heading) {
                    button.setAttribute('aria-label', `Add - ${heading.innerText}`);
                }
            })
        }
    }
}

const fixHeadingMarkup = function(){
    let mainHeading = document.querySelector('#cart-drawer .h5');
    let orderNoteHeading = document.querySelector('#cart-drawer-note .h5');
    let heading2 = document.querySelector('div.cart-drawer__recommendations > div > div > p')
    
    if(mainHeading) {
        mainHeading.setAttribute('role', 'heading');
        mainHeading.setAttribute('aria-level', 2);
    }

    if(heading2) {
        heading2.setAttribute('role', 'heading');
        heading2.setAttribute('aria-level', 3);
    }

    if(orderNoteHeading) {
        orderNoteHeading.setAttribute('role', 'heading');
        orderNoteHeading.setAttribute("aria-level", 3);
    }
}

const removeProgressBarAttr = function(){
    let progressBar = document.querySelector('#cart-drawer .progress-bar');
    if(progressBar){
        progressBar.removeAttribute('role');
        progressBar.removeAttribute('aria-valuenow');
        progressBar.removeAttribute('aria-valuemin');
        progressBar.removeAttribute('aria-valuemax');
    }
}

function addHeadingsToTrendingItems() {
    const reversedLinks = document.querySelectorAll('.cart-drawer__recommendations .reversed-link.hover\\:show');
    reversedLinks.forEach((link) => {
        link.setAttribute('role', 'heading');   
        link.setAttribute('aria-level', '4');
    });
}

function focusAddToCartButtonOnClose() {
    const closeButton = document.querySelector('.modal .close-button');
    const form = document.querySelector('product-info__buy-buttons form');
    const addToCartButton = form?.querySelector('button[type="submit"]');

    if (!closeButton || !addToCartButton) return;

    closeButton.addEventListener('click', () => {
        setTimeout(() => {
            addToCartButton.focus();
        }, 0);
    });
}

function fixFooterRole(){
  const footerShadowRoot = document.querySelector('#cart-drawer').shadowRoot;
  if(footerShadowRoot) {
    const footerElem = footerShadowRoot.querySelector('footer');
    if(footerElem) footerElem.setAttribute("role","presentation");
  }
}

function observeCartDrawer() {
  const cartDrawer = document.getElementById("cart-drawer");

  if (!cartDrawer) return;

  const cartParent = cartDrawer.parentElement; // Get the parent of the cart drawer

  const bodyChildren = [...document.body.children].filter(
    (child) => child !== cartDrawer && child !== cartParent // Exclude cart drawer and its parent
  );

  const applyInert = (isVisible) => {
    bodyChildren.forEach((child) => {
      if (isVisible) {
        child.setAttribute("inert", "");
      } else {
        child.removeAttribute("inert");
      }
    });
  };

  const checkVisibility = () => {
    const isVisible =
      getComputedStyle(cartDrawer).visibility !== "hidden" &&
      getComputedStyle(cartDrawer).opacity !== "0";

    applyInert(isVisible);
  };

  // Observer to detect changes in cart visibility
  const observer = new MutationObserver(checkVisibility);
  observer.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ["style"],
  });

  // Add event listeners to ensure visibility check on open/close
  document.body.addEventListener("click", (event) => {
    const cartToggle = event.target.closest('a[href="/cart"][aria-controls="cart-drawer"]');
    if (cartToggle) {
      setTimeout(checkVisibility, 50);
    }
  });

  // Initial check without applying `inert`
  checkVisibility();
}

function addLabelToAllInputs() {
  const cartDrawer = document.getElementById("cart-drawer");
  if (!cartDrawer) {
    return;
  }

  const lineItems = cartDrawer.querySelectorAll(".line-item");

  if (lineItems.length === 0) {
    return;
  }

  lineItems.forEach((line) => {
    let inputs = line.querySelectorAll("input");

    if (inputs.length === 0) {
      return;
    }

    inputs.forEach((input, index) => {
      if (!input.parentNode.querySelector(`label[for="${input.id}"]`)) {
        const label = document.createElement("label");
        label.textContent = input.type === "number" ? "Quantity" : "Input";
        label.classList.add("custom-input-label");

        if (!input.id) {
          input.id = `input-${Math.random().toString(36).substring(2, 9)}`;
        }

        label.setAttribute("for", input.id);
        input.parentNode.insertBefore(label, input);
      }
    });
  });
}

A11y.applyCartModalFixes = function () {
  const cartDrawer = document.querySelector("#cart-drawer");
  const observer = new MutationObserver((mutationsList) => {
    for (let mutation of mutationsList) {
      if (mutation.type === "childList") {
        if (cartDrawer) {
          setCartHeading();
          addLabelToAllInputs();
          fixRemoveButtonLabel();
          trendingCardsAddButtonsLabel();
          fixHeadingMarkup();
          removeProgressBarAttr();
          removeAriaExpanded();
          removeAriaExpandedFromButton();
          addHeadingsToTrendingItems();
          focusAddToCartButtonOnClose();
          fixFooterRole();
          observeCartDrawer();
          break;
        }
      }
    }
  });

  if (cartDrawer) {
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  document.body.addEventListener("click", (event) => {
    const cartToggle = event.target.closest('a[href="/cart"][aria-controls="cart-drawer"]');
    if (cartToggle) {
      setTimeout(() => {
        cartToggle.removeAttribute("aria-expanded");
      }, 10);
    }
  });
};
})(window.A11y = window.A11y || {});

/* ===== A11y_cartDetailedPage.js ===== */
(function(A11y){
const setAriaLabel = function(selector, containerSelector, prefix){
    let elements = document.querySelectorAll(selector);
    elements.forEach(element => {
        let container = element.closest(containerSelector);
        if (container) {
            let heading = container.querySelector(containerSelector + ' div.line-item__info a span').innerText;
            element.setAttribute('aria-label', `${prefix} - ${heading}`);
        }
    });
}
const fixAddQuantityLabel = function(){
    setAriaLabel('tbody.order-summary__body td.align-center input.quantity-input', 'tr', 'Change quantity for - ');
}

const fixRemoveButtonLabel = function() {
    setAriaLabel('tbody.order-summary__body td.align-center a.link', 'tr', 'Remove - ');
}


const fixHeadingMarkup = function(){
    let headings = document.querySelectorAll('.cart-order__recap .text-xs, .accordion__toggle span.h6');
    if(headings) {
        headings.forEach(heading => {
            heading.setAttribute('role', 'heading'); heading.setAttribute('aria-level',3);
        });   
    }
}

const addRowHeader = function(){
    let tbody = document.querySelector('.order-summary__body');
    let rows = tbody.querySelectorAll('tr');

    rows.forEach(function(row) {
        var firstTd = row.querySelector('td:first-child');
        if (firstTd) {
            firstTd.setAttribute('role', 'rowHeader');
        }
    });
}

const removeProgressBarAttr = function(){
    let progressBar = document.querySelector('.cart-header .progress-bar');
    if(progressBar){
        progressBar.removeAttribute('role');
        progressBar.removeAttribute('aria-valuenow');
        progressBar.removeAttribute('aria-valuemin');
        progressBar.removeAttribute('aria-valuemax');
    }
}

function addAriaAttributeToAnElement(
  elementSelector,
  attributeKey,
  attributeValue
) {
  let elements = document.querySelectorAll(elementSelector);
  elements.forEach((element) => {
    element.setAttribute(attributeKey, attributeValue);
  });
}
    


A11y.shoppingCartFixes = function(){
    if(window.location.href.includes("/cart")){
        fixHeadingMarkup();
        fixAddQuantityLabel();
        fixRemoveButtonLabel();
        addRowHeader();
        removeProgressBarAttr();
        addAriaAttributeToAnElement("table.order-summary tbody input.quantity-input", "title", "Pressing the 'Tab' key after changing the quantity will refresh the page.");
    }
}
})(window.A11y = window.A11y || {});

/* ===== A11y_aboutUsPage.js ===== */
(function(A11y){
const fixHeadingMarkup = function(){
    let allHeadings = document.querySelectorAll('p.h1');
    if(allHeadings.length > 0){
        allHeadings.forEach(heading => {
            heading.setAttribute('role', 'heading');
            heading.setAttribute('aria-level', '2');
        });
    }
}

A11y.applyAboutUsFixes = () => {
    if(window.location.href.includes("/our-story")){
        fixHeadingMarkup();
    }
}
})(window.A11y = window.A11y || {});

/* ===== A11y_allFieldNotesPage.js ===== */
(function(A11y){
const emailErrorAssociation = function(){
    let form = document.querySelector('#blog-newsletter');
    if(form){
        let emailInput = form.querySelector('input[type="email"]');
        let errorDiv = form.querySelector('div.banner--error');
        if(emailInput && errorDiv){
            errorDiv.setAttribute('role', 'alert');
            errorDiv.setAttribute('id','email-error');
            emailInput.setAttribute('aria-describedby','email-error');
        }
    }
}

const addHeadingMarkup = function(){
    let heading = document.querySelector('.blog-post-card__info p.h2');
    if(heading){
        heading.setAttribute('role', 'heading');
        heading.setAttribute('aria-level', '2');
    }
}

A11y.applyAllFieldFixes = function(){
    if(window.location.href.includes('/blogs')){
        addHeadingMarkup();
        emailErrorAssociation();
    }
}
})(window.A11y = window.A11y || {});

/* ===== A11y_orderPage.js ===== */
(function(A11y){
// Function to change the page title of a page
const modifyPageTitle = function() {
    let titleElement = document.querySelector("head > title");
    let existingTitle = titleElement.innerText;
    let modifiedTitle = existingTitle.replace("Account", "Orders");
    titleElement.innerText = modifiedTitle;
}

// Function to set an aria role or attribute on an element
const setAriaAttribute = function(elementSelector, ariaAttributeKey, ariaAttributeValue) {
    let elements = document.querySelectorAll(elementSelector);

    // Iterating through all elements and setting expected attribute
    elements.forEach((element) => {
        element.setAttribute(ariaAttributeKey, ariaAttributeValue);
    });
}

// Function to add link semantics to entries present in the "Order" column
const provideLinkRoleToOrders = function() {
    // Selecting all cells of "Orders" column
    let orderIDCells = document.querySelectorAll("table.order-table-list tbody tr > td:first-child");

    // Iterating through the selected cells, creating a <span> element, implementing the span as a link, and then appending it to the respective cells
    orderIDCells.forEach((orderIDCell) => {
        let cellValue = orderIDCell.innerText;
        let spanElement = document.createElement("span");

        // Adding role="link" and tabindex attribute to the <span> element. Also adding innerText
        spanElement.setAttribute("role", "link");
        spanElement.setAttribute("tabindex", "0");
        spanElement.innerText = cellValue;

        // Attaching a keydown event on the spanElement (Link), to click the element when 'Enter' key of keyboard is pressed
        spanElement.addEventListener("keydown", function (event) {
            if (event.key === "Enter") {
                event.target.click();
            }
        });

        // Appending the spanElement (Link) in the <td> element
        orderIDCell.innerText = "";
        orderIDCell.appendChild(spanElement);
    });
}

// Main function
A11y.applyFixesForOrderPage = function() {
    if (window.location.pathname === "/account") {
        // Modifying the page title to "Orders"
        modifyPageTitle();

        // Setting aria-current="page" on the current/active pagination element
        setAriaAttribute("nav.pagination span.pagination__current", "aria-current", "page");

        // Setting an accessible label for the Orders table
        setAriaAttribute("table.order-table-list", "aria-label", "Orders");

        // Adding link semantics to entries present in the "Order" column
        provideLinkRoleToOrders();
    }
}
})(window.A11y = window.A11y || {});

/* ===== A11y_addressPage.js ===== */
(function(A11y){
// Function to provide heading semantics to a text
const provideHeadingSemantics = function(headingElementSelector, headingLevel) {
    let headingElements = document.querySelectorAll(headingElementSelector);
    
    headingElements.forEach((heading) => {
        heading.setAttribute("role", "heading");
        heading.setAttribute("aria-level", headingLevel);
    });
};

// Function to add list mark-up to addresses
const provideListMarkUp = function(ListSelector, listItemSelector) {
    let list = document.querySelector(ListSelector);
    let listItems = document.querySelectorAll(listItemSelector);
    
    // Adding role="list" attribute on the list element
    list.setAttribute("role", "list");
    
    // Adding role="listitem" to all list items
    listItems.forEach((listItem) => {
        listItem.setAttribute("role", "listitem");
    });
};

// Function to remove an attribute from an element
const removeUnnecessaryAttribute = function(elementSelector, attributeName) {
    let elements = document.querySelectorAll(elementSelector);
    
    elements.forEach((element) => {
        element.removeAttribute(attributeName);
    });
};

// Function to provide unique labels to "Edit" and "Remove" buttons
const provideUniqueLabelsToEditAndDeletesections = function(sectionSelectors) {
    let sections = document.querySelectorAll(sectionSelectors);
    
    // Iterating through the sections, extracting the section title (Address number), and then generating unique labels
    sections.forEach((section) => {
        let actionButtons = section.querySelectorAll("button");
        let sectionName = section.querySelector("p.bold").innerText;
        
        // Implementing unique label using aria-label
        actionButtons.forEach((actionButton) => {
            let uniqueLabel = `${actionButton.innerText} (${sectionName})`;
            actionButton.setAttribute("aria-label", uniqueLabel);
        });
    });
};

const  labellingUnlabelledFormControls = function() {
    const addressModals = document.querySelectorAll("x-drawer");
    addressModals.forEach(addressModal => {
        const formControls =  addressModal.querySelectorAll("form input:not([type='hidden']), form select");
        formControls.forEach(formControl => {
            const label = formControl.parentElement.lastElementChild.textContent;
            formControl.setAttribute("aria-label", label);
        });
    });
}

A11y.applyFixesOnAddressPage = function () {
    if (window.location.pathname === "/account/addresses") {
        // Providing heading semantics to addresses
        provideHeadingSemantics("div.addresses-list p.bold", "2");
        
        // Providing list semantics to addresses
        provideListMarkUp("div.addresses-list", "div.addresses-list > div");
        
        // Removing aria-expanded attribute from "Edit" buttons
        removeUnnecessaryAttribute("div.addresses-list div.address__actions > button[aria-expanded]", "aria-expanded");
        removeUnnecessaryAttribute("div.justify-self-center button.button.button--xl[aria-expanded]", "aria-expanded");
        
        // Providing unique labels to "Edit" and "Remove" buttons
        provideUniqueLabelsToEditAndDeletesections("div.addresses-list > div");
        
        const observer = new MutationObserver((mutationsList, observer) => {
            for (let mutation of mutationsList) {
                if (mutation.type === "childList") {
                    labellingUnlabelledFormControls();
                }
            }
        });
        const config = {
            childList: true,
            subtree: true,
        };
        
        observer.observe(document.body, config);

    }
}
})(window.A11y = window.A11y || {});

/* ===== A11y_orderDetailsPage.js ===== */
(function(A11y){
const provideHeadingSemantics = function(headingElementSelector, headingLevel) {
    let headingElements = document.querySelectorAll(headingElementSelector);
    
    headingElements.forEach((heading) => {
        heading.setAttribute("role", "heading");
        heading.setAttribute("aria-level", headingLevel);
    });
};

const provideListMarkUp = function(ListSelector, listItemSelector) {
    let list = document.querySelector(ListSelector);
    let listItems = document.querySelectorAll(listItemSelector);
    
    // Adding role="list" attribute on the list element
    list.setAttribute("role", "list");
    
    // Adding role="listitem" to all list items
    listItems.forEach((listItem) => {
        listItem.setAttribute("role", "listitem");
    });
};

const setAriaAttribute = function(elementSelector, ariaAttributeKey, ariaAttributeValue) {
    let elements = document.querySelectorAll(elementSelector);
    
    // Iterating through all elements and setting expected attribute
    elements.forEach((element) => {
        element.setAttribute(ariaAttributeKey, ariaAttributeValue);
    });
};

A11y.applyOrderDetailFixes = function() {
    if (window.location.pathname.startsWith("/account/orders")) {
        // Providing heading semantics to "Billing address" and "Shipping address" texts.
        provideHeadingSemantics("div.order-addresses-list p.bold", "2");
        
        // Providing list mark-up to billing details present in the last row of order summary table
        provideListMarkUp("table.order-summary tfoot div.v-stack.gap-2.text-start", "table.order-summary tfoot div.v-stack.gap-2.text-start > div");
        
        // Setting alt="" on the product images present under the "Product" column
        setAriaAttribute("table.order-summary tbody tr td:first-child img", "alt", "");
        
        // Setting role="rowheader" on cells of the "Product" column
        setAriaAttribute("table.order-summary tbody tr td:first-child", "role", "rowheader");
    }
};

// Calling applyOrderDetailFixes function
A11y.applyOrderDetailFixes();
})(window.A11y = window.A11y || {});

/* ===== A11y_TermsOfUsePage.js ===== */
(function(A11y){
function selectParagraphsWithNumberedList() {
    // Select all <p> elements in the document
    const paragraphs = document.querySelectorAll('.prose p');
  
    // Regular expression to match patterns like "1.1", "1.2", "1.10", etc.
    const regex = /1\.\d+/;
  
    // Array to store matching <p> elements
    const matchingParagraphs = [];
  
    // Loop through all <p> elements
    paragraphs.forEach(p => {
      // Check if the text content matches the regex
      if (regex.test(p.textContent)) {
        matchingParagraphs.push(p);
      }
    });
  
    return matchingParagraphs;
  }
  function addHeadingRoles() {
      const headings = document.querySelectorAll('h1, h2');
      headings.forEach(heading => {
          const text = heading.textContent.trim();
          if (text === "Mobile Terms of Service" || "Website Terms of Service" || "Do not sell my personal information") {
              heading.setAttribute('role', 'heading');
              heading.setAttribute('aria-level', '2');
          }
          else if (text === "Arlo Skye") {
              heading.setAttribute('role', 'heading');
              heading.setAttribute('aria-level', '3');
          }
      });
  }
  
  A11y.applyTermsOfUseFixes = () => {
    if (window.location.href.includes("/pages/terms-of-use")) {
      const matchingParagraphs = selectParagraphsWithNumberedList();
      matchingParagraphs.forEach((p) => {
        p.setAttribute("role", "heading");
        p.setAttribute("aria-level", "3");
      });
      addHeadingRoles();
    }
    if(window.location.href.includes("/pages/ccpa-opt-out")){
      addHeadingRoles();
    }
  };
})(window.A11y = window.A11y || {});

/* ===== A11y_forgetPasswordPage.js ===== */
(function(A11y){
const modifyPageTitle = function(){
	let pageTitleElement = document.querySelector("head > title");
	let forGotPasswordLink = document.querySelector("#customer_login a[href='#recover']");
	let returnToLogInLink = document.querySelector("#recover > form a[href='#login']");
	// Attaching a click event on the "Forgot Password" link. On activation of the link, page title will change to "Recover password".
	forGotPasswordLink.addEventListener("click", function () {
		pageTitleElement.innerText = "Recover password";
		// Attaching a click event on the "Return to login" link. On activation of the link, page title will change to "Log In".
		returnToLogInLink.addEventListener("click", function () {
			pageTitleElement.innerText = "Log In";
		});
	});
}

A11y.applyForgetPaswordPageFixes = function(){
    if (window.location.href.includes("/login")) {
        modifyPageTitle();
    }
}
})(window.A11y = window.A11y || {});

/* ===== A11y_CheckoutPage.js ===== */
(function(A11y){
A11y.applyCheckoutFixes = () => {
    if (!window.location.href.includes("/checkouts/")) return;

    console.log("Checkout page detected, applying fixes...");

    function observeCreditCardButton() {
        const button = document.querySelector('button[aria-pressed]');

        if (!button) {
            console.warn("Button with aria-pressed not found.");
            return;
        }

        const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach(mutation => {
                if (mutation.attributeName === "aria-pressed") {
                    const isPressed = button.getAttribute("aria-pressed") === "true";

                    if (isPressed) {
                        const describedById = button.getAttribute("aria-describedby");

                        if (describedById) {
                            const describedElement = document.getElementById(describedById);

                            if (describedElement) {
                                console.log("Described element:", describedElement.textContent);
                            } else {
                                console.warn("Element with ID", describedById, "not found in the DOM.");
                            }
                        } else {
                            console.warn("aria-describedby attribute not found on the button.");
                        }
                    }
                }
            });
        });

        observer.observe(button, { attributes: true });
    }

    // Apply the fix when the script runs
    observeCreditCardButton();
};
})(window.A11y = window.A11y || {});

/* ===== A11y_OrdersPage.js ===== */
(function(A11y){
function observePortalAndModal() {
    const portalHost = document.getElementById("PortalHost");
    console.log("Applying Order Page Fixes");
    if (!portalHost) {
        console.warn("PortalHost not found.");
        return;
    }

    const portalObserver = new MutationObserver(() => {
        const portal2 = document.getElementById("Portal2");

        if (portal2) {
            console.log("Portal2 detected inside PortalHost.");

            // Stop observing once Portal2 is detected
            portalObserver.disconnect();

            // Start observing Portal2 for Modal5
            const modalObserver = new MutationObserver(() => {
                const modal = document.getElementById("Modal5");

                if (modal) {
                    console.log("Modal5 detected inside Portal2!");
                    modalObserver.disconnect(); // Stop observing once found
                }
            });

            modalObserver.observe(portal2, { childList: true, subtree: true });
        }
    });

    portalObserver.observe(portalHost, { childList: true, subtree: true });
}
A11y.applyOrderFixes = () => {
    if (window.location.href.includes("/customeraccounts.arloskye.com/orders")) {
        observePortalAndModal();
    }
  };
})(window.A11y = window.A11y || {});

/* ===== A11y_OrderArrivalTimes.js ===== */
(function(A11y){
const headingFixes = function(){
    let headings = document.querySelectorAll('.page strong');
    if(headings.length > 0){
      headings.forEach((heading)=>{
        heading.setAttribute("role","heading");
        heading.setAttribute("aria-level",2);
      })
    }
  }
  
  A11y.applyOrderArrivalTimesFixes = () => {
      if (window.location.href.includes("/order-arrival-times")){
        headingFixes();
      };
  }
})(window.A11y = window.A11y || {});

/* ===== A11y_FrequentlyAskedQuestions.js ===== */
(function(A11y){
const headingFixes = function(selector,ariaLevel){
    const allHeadings = document.querySelectorAll(selector);
    if(allHeadings.length > 0){
      allHeadings.forEach((heading)=>{
        heading.setAttribute("role","heading");
        heading.setAttribute("aria-level",ariaLevel);
      })
    }
  }


function addAriaListRoles() {
  const sections = document.querySelectorAll("#main > section");

  if (!sections.length) {
    return;
  }

  sections.forEach((section, sectionIndex) => {
    const detailsElements = section.querySelectorAll("details");

    if (!detailsElements.length) {
      return;
    }

    detailsElements.forEach((details, detailsIndex) => {
      const accordionContents = details.querySelectorAll(".accordion__content");

      if (!accordionContents.length) {
        return;
      }

      accordionContents.forEach((accordionContent, contentIndex) => {
        const proseContainer = accordionContent.querySelector(".prose");
        if (!proseContainer) {
          return;
        }
        const paragraphs = Array.from(proseContainer.querySelectorAll("p"));
        if (!paragraphs.length) {
          return;
        }
        // Set role="list" to .prose
        proseContainer.setAttribute("role", "list");

        // Set role="listitem" to each <p> inside .prose, except those containing <strong>
        paragraphs.forEach((paragraph, pIndex) => {
          if (!paragraph.querySelector("strong")) {
            paragraph.setAttribute("role", "listitem");
          }
        });
      });
    });
  });
}

function fixLinkElement() {
  const linkElement = document.querySelector('a[href="https://cdn.shopify.com/s/files/1/1534/9745/files/Arlo_Skye_Charger_Brochure__190x210_mm__080824.pdf?v=1723173621"][title="https://cdn.shopify.com/s/files/1/1534/9745/files/Arlo_Skye_Charger_Brochure__190x210_mm__080824.pdf?v=1723173621"]');
  if (linkElement) {
    linkElement.setAttribute('aria-label', 'Download the Arlo Skye Charger Brochure PDF');
  }
}

  A11y.applyFAQFixes = () => {
      if (window.location.href.includes("/frequently-asked-questions-faq")){
        headingFixes('#main .accordion__toggle span',3);
        headingFixes('.accordion__content strong',4);
        addAriaListRoles();
        fixLinkElement();
      };
  }
})(window.A11y = window.A11y || {});

/* ===== A11y_Warranty.js ===== */
(function(A11y){
const headingFixes = function(selector,ariaLevel){
    const allHeadings = document.querySelectorAll(selector);
    if(allHeadings.length > 0){
      allHeadings.forEach((heading)=>{
        heading.setAttribute("role","heading");
        heading.setAttribute("aria-level",ariaLevel);
      })
    }
  }
  
  A11y.applyWarrantyFixes = () => {
      if (window.location.href.includes("/warranty")){
        headingFixes('.section-stack__intro strong',3);
        headingFixes('.accordion__toggle span',3);
      };
  }
})(window.A11y = window.A11y || {});

/* ===== A11y_Reviews.js ===== */
(function(A11y){
const updateReadMoreButtons = () => {
    const reviewContainers = document.querySelectorAll(".oke-w-reviews-list-item");
    if (!reviewContainers || reviewContainers.length === 0) {
      return;
    }
    reviewContainers.forEach(container => {
      if (!container) {
        return;
      }
      const headingElement = container.querySelector(".oke-product-details a");
      if (!headingElement) {
        return; 
      }
      const headingText = headingElement?.textContent?.trim() || "this product";
      if (!headingElement.querySelector(".oke-a11yText")) {
        const a11ySpan = document.createElement("span");
        a11ySpan.classList.add("oke-a11yText");
        a11ySpan.textContent = headingText;
        headingElement.appendChild(a11ySpan);
      } 
      const truncatedReview = container.querySelector(".oke-w-review-main .oke-is-truncated");
      if (!truncatedReview) {
        return;
      }
      const readMoreButton = container.querySelector(".oke-readMore");
      if (!readMoreButton) {
        return;
      }
      if (!readMoreButton.querySelector(".oke-a11yText")) {
        const readMoreA11ySpan = document.createElement("span");
        readMoreA11ySpan.classList.add("oke-a11yText");
        readMoreA11ySpan.textContent = ` for ${headingText}`;
        readMoreButton.appendChild(readMoreA11ySpan);
      }
    });
  };
  
  A11y.applyReviewsFixes = () => {
    if (window.location.href.includes("/reviews")) {
      if (document.readyState === "complete") {
        updateReadMoreButtons();
      } else {
        window.addEventListener("load", updateReadMoreButtons);
      }
    }
  };
})(window.A11y = window.A11y || {});

/* ===== A11y_ReturnAndExchanges.js ===== */
(function(A11y){
const headingFixes = function(selector,ariaLevel){
    let headings = document.querySelectorAll(selector);
    if(headings.length > 0){
      headings.forEach((heading)=>{
        heading.setAttribute("role","heading");
        heading.setAttribute("aria-level",ariaLevel);
      })
    }
  }
  
  const updateAriaLabels = () => {
    document.querySelectorAll("details.accordion").forEach(details => {
      if (!details) {
        return;
      }
      const headingElement = details.querySelector("span[role='heading'][aria-level='3']");
      if (!headingElement) {
        return;
      }
      const headingText = headingElement.textContent.trim();
  
      const anchorElement = details.querySelector("a");
      if (!anchorElement) {
        return;
      }
      anchorElement.setAttribute("aria-label", headingText);
    });
  };
  
  A11y.applyReturnAndExchangesFixes = () => {
      if (window.location.href.includes("/returns-and-exchanges")){
        headingFixes('.section-stack__intro strong',3);
        headingFixes('.accordion__toggle span',3);
        updateAriaLabels();
      };
  }
})(window.A11y = window.A11y || {});

/* ===== A11y_Compare.js ===== */
(function(A11y){
function addAriaLabelToColorOptions() {
    const productContainers = document.querySelectorAll('.feature-chart__table-row--product');
    productContainers.forEach(container => {
        const productElements = container.querySelectorAll('.feature-chart__product');
        productElements.forEach(product => {
            const linkElement = product.querySelector('a.line-clamp');
            if (linkElement) {
                const heading = linkElement.textContent.trim();
                const colorOptionsContainer = product.querySelector('.h-stack');
                if (colorOptionsContainer) {
                    const colorAnchors = colorOptionsContainer.querySelectorAll('a'); // Select anchors inside the color options container
                    colorAnchors.forEach(anchor => {
                        const color = anchor.textContent.trim();
                        anchor.setAttribute('aria-label', `Choose color ${color} for ${heading}`);
                    });
                }
            }
        });
    });
}

function fixTableAccessibility() {
  const tableContainer = document.querySelector('.feature-chart__table');
  if(!tableContainer) {
    console.log('Table container not found.');
    return;
  }
  tableContainer.setAttribute('role', 'table');
  tableContainer.setAttribute('aria-label', 'Product Comparison Table');
  const rows = tableContainer.querySelectorAll('.feature-chart__table-row');
  rows.forEach((row, rowIndex) => {
    row.setAttribute('role', 'row');
    const isHeaderRow = row.classList.contains('feature-chart__table-row--product');
    const isDataRow = !isHeaderRow;
    const cells = row.querySelectorAll('.feature-chart__product, .feature-chart__heading, .feature-chart__value');

    cells.forEach((cell, cellIndex) => {
      if (isHeaderRow) {
        cell.setAttribute('role', 'columnheader');
        cell.setAttribute('scope', 'col');
      } else if (isDataRow) {
        if (cell.classList.contains('feature-chart__heading')) {
          cell.setAttribute('role', 'rowheader');
          cell.setAttribute('scope', 'row');
        } else {
          cell.setAttribute('role', 'cell');
        }
      }
    });
  });
}

function hideInputFromScreenReader(selector) {
  const inputs = document.querySelectorAll(selector);
  if (inputs.length > 0) {
    inputs.forEach((input) => {
      input.setAttribute('tabindex', '-1'); 
      input.setAttribute('aria-hidden', 'true');
    });
  }
}

function addAriaCurrentToSelectedLink(selector) {
  const selectedLinks = document.querySelectorAll(selector);
  if (selectedLinks.length > 0) {
      selectedLinks.forEach((link) => {
        link.setAttribute('aria-current', 'true');
    });
  }
}
function updateColorSwatchTitles() {
    document.querySelectorAll('.color-swatch').forEach(label => {
        const span = label.querySelector('span.sr-only');
        if (span) {
            label.setAttribute('title', span.textContent.trim());
        }
    });
}

A11y.applyComparePageFixes = () => {
  if (window.location.href.includes("/compare")) {
    addAriaLabelToColorOptions();
    fixTableAccessibility();
    updateColorSwatchTitles();
    hideInputFromScreenReader('.feature-chart__table-row--product input[type="radio"]');
    addAriaCurrentToSelectedLink('.feature-chart__table-row--product a.is-selected');
  }
};
})(window.A11y = window.A11y || {});

/* ===== runner ===== */
document.addEventListener("readystatechange", function (event) {
    if (event.target.readyState === "complete") {
        var A = window.A11y;
        try {
            if (typeof A.applyCriticalFixes === 'function') A.applyCriticalFixes();
            if (typeof A.applyLoginPageFixes === 'function') A.applyLoginPageFixes();
            if (typeof A.applyHeaderFixes === 'function') A.applyHeaderFixes();
            if (typeof A.applyHomePageFixes === 'function') A.applyHomePageFixes();
            if (typeof A.applyFooterFixes === 'function') A.applyFooterFixes();
            if (typeof A.applyCartFixes === 'function') A.applyCartFixes();
            if (typeof A.applyProductListFixes === 'function') A.applyProductListFixes();
            if (typeof A.applyPDPFixes === 'function') A.applyPDPFixes();
            if (typeof A.applyCartModalFixes === 'function') A.applyCartModalFixes();
            if (typeof A.shoppingCartFixes === 'function') A.shoppingCartFixes();
            if (typeof A.applyAboutUsFixes === 'function') A.applyAboutUsFixes();
            if (typeof A.applyAllFieldFixes === 'function') A.applyAllFieldFixes();
            if (typeof A.applyFixesForOrderPage === 'function') A.applyFixesForOrderPage();
            if (typeof A.applyFixesOnAddressPage === 'function') A.applyFixesOnAddressPage();
            if (typeof A.applyOrderDetailFixes === 'function') A.applyOrderDetailFixes();
            if (typeof A.applyTermsOfUseFixes === 'function') A.applyTermsOfUseFixes();
            if (typeof A.applyForgetPaswordPageFixes === 'function') A.applyForgetPaswordPageFixes();
            if (typeof A.applyCheckoutFixes === 'function') A.applyCheckoutFixes();
            if (typeof A.applyOrderFixes === 'function') A.applyOrderFixes();
            if (typeof A.applyOrderArrivalTimesFixes === 'function') A.applyOrderArrivalTimesFixes();
            if (typeof A.applyFAQFixes === 'function') A.applyFAQFixes();
            if (typeof A.applyWarrantyFixes === 'function') A.applyWarrantyFixes();
            if (typeof A.applyReviewsFixes === 'function') A.applyReviewsFixes();
            if (typeof A.applyReturnAndExchangesFixes === 'function') A.applyReturnAndExchangesFixes();
            if (typeof A.applyComparePageFixes === 'function') A.applyComparePageFixes();
        } catch (e) {
            console.error('[A11y] error while applying fixes:', e);
        }
        console.log('Document is complete. A11y bundle applied.');
    }
});
